<template>
  <div id="currencies">
    <currencies-add-new
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      :currency-statuses="currencyStatuses"
      :symbol-directions="symbolDirections"
      @refetch-data="refetchData"
    />

    <b-card class="mb-0" body-class="p-0">
      <div class="m-2">
        <b-row>
          <b-col
            cols="6"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="isAddNewSidebarActive = true">
                <span class="text-nowrap">Add New Currency</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- 
        Currencies Table
       -->
      <b-table
        ref="refCurrenciesTable"
        class="position-relative"
        :items="fetchCurrencies"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="isLoading ? 'Loading...' : 'No matching records found'"
      >
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>
        <template #cell(slug)="data">
          {{ data.item.slug }}
        </template>

        <template #cell(isActive)="data">
          <b-form-checkbox
            v-model="data.item.isActive"
            @change="updateCurrency(data.item._id, 'isActive', $event)"
            class="custom-control-success"
            size="lg"
            switch
          />
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button :data-test="data.item._id" size="sm" variant="warning">Edit</b-button>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCurrencies"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BFormCheckbox,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormSpinbutton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import useCurrenciesList from "./useCurrenciesList";
import CurrenciesAddNew from "./CurrenciesAddNew";
import { ref, onUnmounted } from "@vue/composition-api";

import store from "@/store";

export default {
  components: {
    BCard,
    BFormCheckbox,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormSpinbutton,
    CurrenciesAddNew,

    vSelect,
  },

  setup() {
    const isAddNewSidebarActive = ref(false);

    const {
      perPage,
      perPageOptions,
      searchQuery,
      fetchCurrencies,
      tableColumns,
      resolveCurrencyStatusVariant,
      refCurrenciesTable,
      totalCurrencies,
      currentPage,
      dataMeta,
      currencyType,
      changeDisplayOrder,
      currencyStatuses,
      refetchData,
      symbolDirections,
      updateCurrency,
      isLoading,
    } = useCurrenciesList();

    return {
      perPage,
      perPageOptions,
      totalCurrencies,
      searchQuery,
      fetchCurrencies,
      tableColumns,
      resolveCurrencyStatusVariant,
      refCurrenciesTable,
      totalCurrencies,
      currentPage,
      dataMeta,
      currencyType,
      changeDisplayOrder,
      isAddNewSidebarActive,
      currencyStatuses,
      refetchData,
      symbolDirections,
      updateCurrency,
      isLoading,
    };
  },
};
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
